import React from 'react'

const StripeCancel = () => {
  return (
    <div className="container">
      <div className="col">
        <h2 className="text-center">
          決済に失敗しました、もう一度お試しください。
        </h2>
      </div>
    </div>
  )
}

export default StripeCancel
